export type SeasonOverviewFilters = {
  country: string | null;
  seasonIndex: string | null;
};

export const initialSeasonOverviewFilterState: SeasonOverviewFilters = {
  country: null,
  seasonIndex: null,
};

export enum SeasonOverviewFilterType {
  SET_COUNTRY = 'SET_COUNTRY',
  SET_SEASON_INDEX = 'SET_SEASON_INDEX',
  RESET_FILTERS = 'RESET_FILTERS',
}

type GlobalFilterAction =
  | { type: SeasonOverviewFilterType.SET_COUNTRY; payload: string | null }
  | { type: SeasonOverviewFilterType.SET_SEASON_INDEX; payload: string | null }
  | { type: SeasonOverviewFilterType.RESET_FILTERS; payload: void };

export function seasonOverviewFilterReducer(
  state: typeof initialSeasonOverviewFilterState,
  action: GlobalFilterAction,
) {
  switch (action.type) {
    case SeasonOverviewFilterType.SET_COUNTRY:
      return { ...state, country: action.payload };
    case SeasonOverviewFilterType.SET_SEASON_INDEX:
      return { ...state, seasonIndex: action.payload };
    case SeasonOverviewFilterType.RESET_FILTERS:
      return initialSeasonOverviewFilterState;
    default:
      return state;
  }
}

export default seasonOverviewFilterReducer;
